document.addEventListener("turbolinks:before-cache", function() {
   const elementsToExclude = document.querySelector(".form-container, .slide-out-container, .header, .page-overlay, .sidebar-wrapper")
   if (elementsToExclude) {
     elementsToExclude.remove()
   }
 })